/* LPM quiz: native translated copy, live catalog, explicit buying choices. */
(() => {
  const timeoutSignal = ms => { const controller = new AbortController(); setTimeout(() => controller.abort(), ms); return controller.signal; };
  if (customElements.get('lpm-jewelry-quiz')) return;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const normalize = value => String(value || '').trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const flows = {gift: ['recipient', 'catalog', 'category', 'style', 'finish', 'personal', 'budget'], personal: ['personality', 'wardrobe', 'use', 'catalog', 'category', 'style', 'finish', 'personal', 'budget']};
  const finishOption = name => /^(color|colour|cor|finish|acabado|acabamento|material)$/.test(normalize(name));

  class JewelryQuiz extends HTMLElement {
    connectedCallback() {
      if (this.started) {
        if (this.loading && this.abort?.signal.aborted) this.results();
        return;
      }
      const config = this.querySelector('[data-qz-config]');
      if (!config) return;
      try { this.config = JSON.parse(config.textContent); } catch { return; }
      this.started = true;
      const pageHandle = location.pathname.replace(/\/$/, '').split('/').pop();
      this.quizType = pageHandle === 'quiz-personal' ? 'personal' : pageHandle === 'quiz-regalo' ? 'gift' : new URLSearchParams(location.search).get('quiz') === 'personal' || this.config.quizType === 'personal' ? 'personal' : 'gift';
      this.steps = flows[this.quizType];
      this.examples = window.LPMQuizExamples || [];
      this.querySelectorAll('[data-quiz-type]').forEach(link => {
        link.setAttribute('aria-current', link.dataset.quizType === this.quizType ? 'page' : 'false');
      });
      if (this.quizType === 'personal') {
        this.querySelector('.qz-head h1').textContent = this.t('personal_heading');
        this.querySelector('.qz-lead').textContent = this.t('personal_lead');
      }
      this.panel = this.querySelector('[data-qz-panel]');
      this.emailAnswered = new Set();
      this.answers = {buyer: 'neutral', occasion: 'any', ...(this.quizType === 'personal' ? {recipient: 'self', relation: 'self'} : {})};
      this.index = 0;
      this.phase = 'questions';
      this.editing = false;
      this.generation = 0;
      this.root = new URL(this.config.root || '/', location.origin).pathname.replace(/\/?$/, '/');
      this.money = new Intl.NumberFormat(this.config.locale || 'es', {style: 'currency', currency: this.config.currency || 'EUR'});
      this.addEventListener('submit', event => { if (event.target.matches('[data-qz-email]')) { event.preventDefault(); this.sendEmail(event.target); } });
      this.addEventListener('input', event => {
        if (event.target.matches('[data-qz-email] [name=email]') && event.target.value.trim()) this.trackEmail('email_input');
      });
      this.addEventListener('focusin', event => {
        if (event.target.matches('[data-qz-email] [name=email]')) this.trackEmail('email_open');
      });
      this.addEventListener('click', event => this.click(event));
      this.addEventListener('error', event => {
        if (event.target.tagName !== 'IMG') return;
        const frame = event.target.closest('.qz-photo, .qz-card-image');
        if (frame) { frame.classList.add('qz-photo-failed'); frame.textContent = this.t('image_unavailable'); }
        else event.target.hidden = true;
      }, true);
      this.addEventListener('toggle', event => {
        if (event.target.classList?.contains('qz-filters')) this.filtersOpen = event.target.open;
      }, true);
      this.addEventListener('change', event => {
        const field = event.target.dataset.field;
        if (['relation', 'buyer', 'occasion'].includes(field)) { this.emailAnswered.add(field); this.answers[field] = event.target.value; this.track('answer', [], field); }
      });
      document.addEventListener('lpm:quiz-tracking-ready', () => { if (this.isConnected) this.trackVisit(); });
      document.addEventListener('visitorConsentCollected', () => {
        if (!this.isConnected) return;
        if (!window.LPMQuizTracking?.allowed()) { this.observer?.disconnect(); this.trackingRun = null; return; }
        this.trackVisit();
        if (this.index >= this.steps.length && this.recommendations) {
          const tracking = window.LPMQuizTracking;
          if (!tracking.context()) tracking.start(this.quizType, this.config.currency, this.config.locale, this.answers);
          if (!tracking.context()?.completed) tracking.complete(this.answers, this.recommendations.slice(0, this.shown).map((entry,index) => this.productEvent(entry,index)));
          this.observeCards();
        }
      });
      this.querySelector('[data-qz-fallback]').hidden = true;
      this.stateKey = 'lpm-quiz-state-v1:' + this.quizType + ':' + this.config.locale;
      const saved = this.restoreState();
      window.addEventListener('pagehide', () => this.saveState());
      window.addEventListener('pageshow', event => {
        if (event.persisted && this.isConnected && this.index >= this.steps.length) {
          this.restoreScroll = scrollY; this.restoreShown = this.shown;
          this.results(true);
        }
      });
      this.addEventListener('click', () => queueMicrotask(() => this.saveState()));
      this.addEventListener('change', () => this.saveState());
      if (saved && this.index >= this.steps.length) this.results(true);
      else this.render(false);
    }
    saveState() {
      if (!this.stateKey) return;
      const keys = [...this.steps, 'buyer', 'occasion', 'recipient', 'relation'];
      const answers = Object.fromEntries(keys.filter(key => typeof this.answers[key] === 'string').map(key => [key, this.answers[key].slice(0, 60)]));
      try { sessionStorage.setItem(this.stateKey, JSON.stringify({time: Date.now(), answers, index: this.index, phase: this.phase,
        shown: this.shown || 4, scroll: scrollY, emailAnswered: [...this.emailAnswered],
        run: window.LPMQuizTracking?.allowed() ? this.trackingRun : null,
        trackedSteps: window.LPMQuizTracking?.allowed() ? [...(this.trackedSteps || [])] : []})); } catch { /* Optional functional session state. */ }
    }
    restoreState() {
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.stateKey));
        if (!saved || Date.now() - saved.time > 1800000 || !Number.isInteger(saved.index) || saved.index < 0 || saved.index > this.steps.length) return false;
        const keys = new Set([...this.steps, 'buyer', 'occasion', 'recipient', 'relation']);
        for (const [key, value] of Object.entries(saved.answers || {})) if (keys.has(key) && typeof value === 'string' && /^[a-z0-9_-]{1,60}$/.test(value)) this.answers[key] = value;
        if (this.steps.slice(0, saved.index).some(key => !this.answers[key])) return false;
        this.index = saved.index; this.restoreShown = Math.min(100, Math.max(4, Number(saved.shown) || 4));
        this.phase = saved.index >= this.steps.length ? 'results' : 'questions';
        this.restoreScroll = Math.max(0, Number(saved.scroll) || 0);
        this.emailAnswered = new Set((saved.emailAnswered || []).filter(key => keys.has(key)));
        this.resumeRun = saved.run; this.trackedSteps = new Set(saved.trackedSteps || []);
        return true;
      } catch { return false; }
    }
    disconnectedCallback() { this.generation++; this.abort?.abort(); this.observer?.disconnect(); this.clearLoadingStages(); }
    t(key, replacements = {}) {
      return Object.entries(replacements).reduce((text, [name, value]) => text.replaceAll(`{${name}}`, value), this.config.copy[key] || key);
    }
    trackVisit() {
      const tracking = window.LPMQuizTracking;
      if (!tracking?.allowed()) return;
      if (!this.trackingRun || tracking.context()?.run !== this.trackingRun) {
        const resumed = tracking.resume?.(this.resumeRun, this.quizType, this.config.locale);
        const context = resumed || tracking.visit(this.quizType, this.config.currency, this.config.locale);
        if (!resumed) this.trackedSteps = new Set();
        this.resumeRun = null;
        if (!context) return;
        this.trackingRun = context.run; this.trackedSteps ||= new Set();
      }
      const step = this.steps[this.index];
      if (step && !this.trackedSteps.has(step)) {
        this.trackedSteps.add(step);
        tracking.event('step_view', this.answers, [], step);
      }
    }
    track(event, products = [], step = null) {
      const tracking = window.LPMQuizTracking;
      if (!tracking?.allowed()) return;
      this.trackVisit();
      if (event === 'answer' || event === 'step_complete') tracking.start(this.quizType, this.config.currency, this.config.locale, this.answers);
      tracking.event(event, this.answers, products, step);
    }
    productEvent(entry, position) { return {handle: entry.product.handle, variant: Number(entry.variant.id), position}; }
    trackEmail(kind) {
      const tracking = window.LPMQuizTracking;
      if (!tracking?.allowed()) return null;
      this.trackVisit();
      const run = tracking.context()?.run;
      if (!run) return null;
      if (this.emailMetricRun !== run) { this.emailMetricRun = run; this.emailMetrics = new Set(); }
      // Only fixed event names: never transmit the field value or an email hash.
      for (const event of new Set(['email_available', kind])) {
        if (!this.emailMetrics.has(event)) { this.emailMetrics.add(event); tracking.event(event, this.answers); }
      }
      return run;
    }
    observeCards() {
      this.observer?.disconnect();
      if (!window.LPMQuizTracking?.allowed()) return;
      if (this.panel.querySelector('[data-qz-email]')) this.trackEmail('email_available');
      this.seen ||= new Set();
      this.observer = new IntersectionObserver(entries => {
        for (const observed of entries) if (observed.isIntersecting && observed.intersectionRatio >= .5) {
          const index = this.recommendations.findIndex(entry => entry.product.handle === observed.target.dataset.product);
          if (index < 0) continue;
          const entry = this.recommendations[index];
          if (entry.changes?.length) { this.observer.unobserve(observed.target); continue; }
          const key = JSON.stringify([this.answers, entry.product.handle, entry.variant.id]);
          if (!this.seen.has(key)) {this.seen.add(key);this.track('impression', [this.productEvent(entry, index)]);}
          this.observer.unobserve(observed.target);
        }
      }, {threshold: .5});
      this.panel.querySelectorAll('.qz-card-image').forEach(link => {link.dataset.product = link.closest('.qz-card').dataset.product;this.observer.observe(link);});
    }
    amount(cents) { return this.money.format(cents / 100); }
    label(key, value) {
      return key === 'budget' && value !== 'any' ? this.t('budget_limit', {amount: this.amount(Number(value))}) : this.t(`${key}_${value}`);
    }
    image(key) {
      const url = this.config.images[key];
      return this.safeImage(url);
    }
    safeImage(value) {
      if (!value) return '';
      try {
        const url = new URL(value, location.origin);
        return ['https:', 'http:'].includes(url.protocol) && (url.origin === location.origin || url.hostname === 'cdn.shopify.com') ? url.href : '';
      } catch { return ''; }
    }
    click(event) {
      const link = event.target.closest('.qz-card a:not(.qz-cart-link)');
      if (link) {
        const index = this.recommendations.findIndex(entry => entry.product.handle === link.closest('.qz-card').dataset.product);
        if (index >= 0) this.track('click', [this.productEvent(this.recommendations[index], index)]);
      }
      const button = event.target.closest('button');
      if (!button || !this.contains(button) || button.disabled) return;
      if (button.hasAttribute('data-qz-back')) return this.back();
      if (button.hasAttribute('data-reset')) return this.reset();
      if (button.hasAttribute('data-retry')) return this.results();
      if (button.hasAttribute('data-edit')) {
        this.abort?.abort(); this.generation++; this.loading = false;
        this.editAnswers = {...this.answers}; this.emailEditAnswered = new Set(this.emailAnswered);
        this.index = this.steps.indexOf(button.dataset.edit); this.editing = true;
        return this.render();
      }
      if (button.hasAttribute('data-more')) {
        const previous = this.shown;
        this.shown += 4;
        this.renderResults(false);
        this.panel.querySelectorAll('.qz-card h3 a')[previous]?.focus();
        return;
      }
      if (button.hasAttribute('data-add')) return this.add(button);
      if (button.hasAttribute('data-continue')) return this.next();
      if (!button.hasAttribute('data-value')) return;
      const key = this.steps[this.index];
      this.emailAnswered.add(key);
      const previous = this.answers[key];
      this.answers[key] = button.dataset.value;
      // Changing an upstream choice cannot retain a style unavailable in that catalog/category.
      if (['catalog', 'category'].includes(key) && this.answers.style && this.answers.style !== 'any' && !this.styleExamples().some(example => example.style === this.answers.style)) { this.answers.style = 'any'; this.emailAnswered.delete('style'); }
      if (key === 'recipient' && previous !== button.dataset.value) {
        this.emailAnswered.delete('relation');
        this.answers.relation = {self: 'self', partner: 'partner', family: 'family', friend: 'friend', other: 'other'}[button.dataset.value];
      }
      this.track('answer', [], key);
      // A choice completes the step; Back preserves the answer for correction.
      return this.next();
    }
    next() {
      if (!this.answers[this.steps[this.index]]) return;
      this.track('step_complete', [], this.steps[this.index]);
      if (this.editing) { this.editAnswers = null; this.editing = false; this.filtersOpen = false; return this.results(); }
      if (++this.index === this.steps.length) return this.results();
      this.render();
    }
    back() {
      this.abort?.abort(); this.generation++; this.loading = false;
      this.clearLoadingStages();
      if (this.phase === 'loading') { this.index = this.steps.length - 1; this.phase = 'questions'; }
      else if (this.index >= this.steps.length) { this.editAnswers = {...this.answers}; this.emailEditAnswered = new Set(this.emailAnswered); this.index = this.steps.length - 1; this.editing = true; this.phase = 'questions'; }
      else if (this.editing) {
        if (this.editAnswers) this.answers = this.editAnswers;
        if (this.emailEditAnswered) this.emailAnswered = this.emailEditAnswered;
        this.editAnswers = null; this.editing = false; this.filtersOpen = false; return this.results();
      }
      else this.index = Math.max(0, this.index - 1);
      this.render();
    }
    reset() {
      this.abort?.abort(); this.generation++; this.loading = false;
      this.clearLoadingStages();
      this.emailAnswered = new Set();
      this.answers = {buyer: 'neutral', occasion: 'any', ...(this.quizType === 'personal' ? {recipient: 'self', relation: 'self'} : {})};
      this.index = 0; this.phase = 'questions'; this.editing = false; this.editAnswers = null; this.recommendations = []; this.seen = new Set();
      window.LPMQuizTracking?.reset();
      this.trackingRun = null; this.resumeRun = null; this.trackedSteps = new Set();
      try { sessionStorage.removeItem(this.stateKey); } catch {}
      this.render();
    }
    focusHeading() {
      const heading = this.panel.querySelector('h2');
      heading?.focus({preventScroll: true});
      if (heading && (heading.getBoundingClientRect().top < 140 || heading.getBoundingClientRect().top > innerHeight / 2)) {
        heading.scrollIntoView({block: 'start', behavior: 'instant'});
      }
    }
    frame() {
      const total = this.steps.length;
      this.classList.toggle('qz--results', this.phase === 'results');
      this.classList.toggle('qz--loading', this.phase === 'loading');
      this.querySelector('.qz-head').hidden = this.index !== 0 || this.editing;
      this.querySelector('[data-qz-stepbar]').hidden = this.index === 0 && !this.editing;
      this.querySelector('[data-qz-step]').textContent = this.phase === 'questions' ? this.t('step', {current: Math.min(this.index + 1, total), total}) : '';
      this.querySelector('[data-qz-progress]').innerHTML = Array.from({length: total}, (_, i) => `<span class="${i < this.index ? 'done' : i === this.index ? 'current' : ''}"></span>`).join('');
      this.panel.setAttribute('aria-busy', 'false');
    }
    option(key, value, {photo = '', note = false, wide = false, swatch = ''} = {}) {
      return `<button type="button" class="qz-option${wide ? ' qz-option-wide' : ''}" data-value="${escape(value)}" aria-pressed="${this.answers[key] === value}">
        ${photo ? `<span class="qz-photo"><img src="${escape(photo)}" alt="" width="600" height="400" loading="eager"></span>` : ''}
        ${swatch ? `<span class="qz-swatch qz-swatch--${swatch}" aria-hidden="true"></span>` : ''}
        <span class="qz-label">${escape(this.label(key, value))}${note ? `<small>${escape(this.t(`${key}_${value}_note`))}</small>` : ''}</span></button>`;
    }
    field(key, choices, label) {
      return `<label class="qz-field"><span>${escape(this.t(label))}</span><select data-field="${key}">${choices.map(value => `<option value="${value}"${this.answers[key] === value ? ' selected' : ''}>${escape(this.t(`${key}_${value}`))}</option>`).join('')}</select></label>`;
    }
    styleExamples() {
      if (!this.examples.length) return ['simple', 'sparkle', 'color', 'meaning'].map(style => ({style, photo: ''}));
      return ['simple', 'sparkle', 'color', 'meaning'].map(style => this.examples.find(example =>
        example.style === style && (this.answers.category === 'any' || example.category === this.answers.category) &&
        (this.answers.catalog === 'all' || example.audience === this.answers.catalog)
      )).filter(Boolean);
    }
    render(focus = true) {
      this.frame();
      this.trackVisit();
      const key = this.steps[this.index];
      const title = this.answers.recipient === 'self' && ['category', 'style'].includes(key) ? `${key}_self_title` : `${key}_title`;
      let content = '';
      if (['personality', 'wardrobe', 'use'].includes(key)) {
        const values = {personality: ['understated', 'creative', 'sentimental', 'versatile'], wardrobe: ['neutral', 'colorful', 'classic', 'mixed'], use: ['everyday', 'work', 'occasion', 'any']}[key];
        content = `<div class="qz-options qz-options--intro">${values.map(value => this.option(key, value, {note: true})).join('')}</div>`;
      } else if (key === 'recipient') {
        content = `<div class="qz-options qz-options--intro">${['self', 'partner', 'family', 'friend', 'other'].map(value => this.option(key, value, {note: true, wide: value === 'other'})).join('')}</div>`;
      } else if (key === 'catalog') {
        const relations = {partner: ['partner', 'girlfriend', 'boyfriend'], family: ['family', 'mother', 'father', 'sister', 'brother', 'daughter', 'son'], friend: ['friend', 'friend_f', 'friend_m']};
        if (relations[this.answers.recipient]) content += this.field('relation', relations[this.answers.recipient], 'relation_label');
        content += `<details class="qz-buyer"><summary>${escape(this.t('buyer_label'))}</summary>${this.field('buyer', ['neutral', 'female', 'male'], 'buyer_label')}${this.answers.recipient && this.answers.recipient !== 'self' ? this.field('occasion', ['any', 'birthday', 'anniversary', 'thanks'], 'occasion_label') : ''}<p>${escape(this.t('buyer_help'))}</p></details>`;
        content += `<div class="qz-options qz-options--catalog">${['women', 'men', 'all'].map(value => this.option(key, value, {note: true})).join('')}</div>`;
      } else if (key === 'category') {
        const prefix = this.answers.catalog === 'men' ? 'men_' : '';
        content = `<div class="qz-options qz-options--photos">${['necklace', 'earrings', 'bracelet', 'ring'].map(value => this.option(key, value, {photo: this.image(prefix + value)})).join('')}${this.option(key, 'any', {wide: true})}</div>`;
      } else if (key === 'style') {
        content = `<div class="qz-options qz-options--photos">${this.styleExamples().map(example => this.option(key, example.style, {photo: this.safeImage(example.photo), note: true})).join('')}${this.option(key, 'any', {wide: true})}</div>`;
      } else if (key === 'finish') {
        content = `<div class="qz-options">${['gold', 'silver'].map(value => this.option(key, value, {swatch: value})).join('')}${this.option(key, 'any', {wide: true})}</div><p class="qz-note">${escape(this.t('finish_note'))}</p>`;
      } else if (key === 'personal') {
        content = `<div class="qz-options qz-options--personal">${['yes', 'no', 'any'].map(value => this.option(key, value, {note: value !== 'any'})).join('')}</div><p class="qz-note">${escape(this.t('production_note'))}</p>`;
      } else if (key === 'budget') {
        content = `<div class="qz-options">${['2000', '2500', '3500', 'any'].map(value => this.option(key, value)).join('')}</div>`;
      }
      content += `<button type="button" class="qz-cta qz-next" data-continue${!this.answers[key] ? ' disabled' : ''}>${escape(this.t('continue'))} <span aria-hidden="true">→</span></button>`;
      this.panel.innerHTML = `<div class="qz-question"><h2 tabindex="-1">${escape(this.t(title))}</h2><p>${escape(this.t(`${key}_help`))}</p></div>${content}`;
      if (focus) this.focusHeading();
    }
    collection(answers = this.answers) {
      if (answers.catalog === 'men') return {necklace: 'collares-para-hombre', earrings: 'pendientes-de-hombre', bracelet: 'pulseras-para-hombre', ring: 'anillos-para-hombre', any: 'joyas-de-hombre'}[answers.category];
      if (answers.personal === 'yes') return 'joyas-personalizadas';
      // General collections can omit BRAVE. 'All' must truly keep both catalogs open.
      if (answers.catalog === 'all') {
        const pairs = {necklace: ['collares', 'collares-para-hombre'], earrings: ['pendientes-de-mujer', 'pendientes-de-hombre'], bracelet: ['pulseras-de-mujer', 'pulseras-para-hombre'], ring: ['anillos-1', 'anillos-para-hombre']};
        return pairs[answers.category] || 'todas-las-joyas';
      }
      return {necklace: 'collares', earrings: 'pendientes-de-mujer', bracelet: 'pulseras-de-mujer', ring: 'anillos-1', any: 'todas-las-joyas'}[answers.category];
    }
    async catalog(signal, handles = this.collection()) {
      const collections = [handles].flat();
      const pages = await Promise.all(collections.map(handle => this.catalogCollection(handle, signal)));
      return [...new Map(pages.flat().map(product => [product.handle, product])).values()];
    }
    async catalogCollection(handle, signal) {
      if (!handle) throw new Error('catalog');
      const base = new URL(`${this.root}collections/${handle}`, location.origin);
      base.searchParams.set('view', 'quiz-v2-json');
      const products = new Map();
      let page = 1;
      // Bound runaway pagination without presenting an incomplete search as no matches.
      for (let count = 0; count < 100; count++) {
        base.searchParams.set('page', page);
        // Do not send Accept: application/json: Shopify would bypass the Liquid view.
        const response = await fetch(base.pathname + base.search, {signal});
        if (!response.ok) throw new Error('catalog');
        const data = await response.json();
        if (!data || data.version !== 2 || !Array.isArray(data.products) || data.page !== page) throw new Error('catalog-version');
        data.products.forEach(product => { if (product?.handle) products.set(product.handle, product); });
        if (data.next === null) return [...products.values()];
        if (!Number.isInteger(data.next) || data.next !== page + 1) throw new Error('pagination');
        page = data.next;
      }
      throw new Error('pagination-limit');
    }
    personal(product) { return ['engraved', 'cut'].includes(product.kind) || /personaliz|personaliaz|grabable|grabado laser/.test(normalize(product.tags)); }
    finish(variant, product) {
      const values = (product.opciones || []).map((name, index) => finishOption(name) ? variant.opciones?.[index] || '' : '').filter(Boolean);
      const value = normalize(values.length ? values.join(' / ') : variant.titulo || variant.t);
      // Avoid treating rose gold as the yellow gold swatch the customer selected.
      if (/rose|rosa|rosad/.test(value)) return 'other';
      if (/\boro\b|\bouro\b|\bgold\b|dorad|dourad/.test(value)) return 'gold';
      if (/\bplata\b|\bprata\b|\bsilver\b|platead|pratead/.test(value)) return 'silver';
      return 'other';
    }
    variants(product, answers = this.answers) {
      return (product.variantes || []).filter(variant => Number.isSafeInteger(Number(variant.id)) && Number(variant.id) > 0 && Number.isFinite(variant.precio) && variant.precio > 1000 &&
        !(answers.personal === 'yes' && /sin texto|sem texto|without text|sin grabado|sem gravacao/.test(normalize(variant.titulo))) &&
        (answers.finish === 'any' || this.finish(variant, product) === answers.finish) &&
        (answers.budget === 'any' || variant.precio <= Number(answers.budget)))
        .sort((a, b) => a.precio - b.precio);
    }
    styles(product) {
      const tags = normalize(product.tags).split('|');
      const has = pattern => tags.some(tag => pattern.test(tag));
      const curated = style => this.examples.some(example => example.handle === product.handle && example.category === product.category && example.audience === product.audience && example.style === style);
      return {
        simple: curated('simple') || has(/^(liso|lisa|minimalista|minimal|sencillo|cadenitas|eslabones)$/),
        sparkle: curated('sparkle') || has(/^(circonita|circonitas|brillante|brillantes|brillantitos|brillantito|brillo)$/),
        color: curated('color') || has(/^(color|colores|colors|multicolor)$/),
        meaning: curated('meaning') || this.personal(product) || has(/^(inicial|iniciales|letra|letras|corazon|corazones|corazoncito|corazoncitos)$/)
      };
    }
    rank(products, answers = this.answers) {
      return products.filter(product => {
        if (!['necklace', 'earrings', 'bracelet', 'ring'].includes(product.category)) return false;
        if (answers.category !== 'any' && product.category !== answers.category) return false;
        if (answers.catalog !== 'all' && product.audience !== answers.catalog) return false;
        if (answers.personal === 'yes' && !this.personal(product)) return false;
        if (answers.personal === 'no' && this.personal(product)) return false;
        return this.variants(product, answers).length > 0 && this.safeImage(product.foto);
      }).map(product => {
        const styles = this.styles(product);
        const match = answers.style !== 'any' && !!styles[answers.style];
        let score = match ? 100 : 0;
        const traits = [];
        if (this.quizType === 'personal') {
          const preferred = {understated: 'simple', creative: 'color', sentimental: 'meaning'}[answers.personality];
          if (preferred && styles[preferred]) { score += 8; traits.push('personality_' + answers.personality); }
          const wardrobe = {neutral: 'simple', colorful: 'color', classic: 'sparkle'}[answers.wardrobe];
          if (wardrobe && styles[wardrobe]) { score += 5; traits.push('wardrobe_' + answers.wardrobe); }
          const use = {everyday: 'simple', work: 'simple', occasion: 'sparkle'}[answers.use];
          if (use && styles[use]) { score += 5; traits.push('use_' + answers.use); }
        }
        // Occasion only ranks motifs explicitly present in catalog tags; no invented claims.
        if (answers.recipient !== 'self' && answers.occasion === 'anniversary' && /(^|\|)(san valentin|corazon|corazones|love|amor)(\||$)/.test(normalize(product.tags))) score += 3;
        if (['mother', 'father'].includes(answers.relation) && normalize(product.tags).split('|').includes(answers.relation === 'mother' ? 'madre' : 'padre')) score += 2;
        if (normalize(product.tags).split('|').includes('topventas')) score += 1;
        return {product, variant: this.variants(product, answers)[0], styles, match, score, traits};
      }).sort((a, b) => b.score - a.score || a.product.handle.localeCompare(b.product.handle));
    }
    deviations(product, variant) {
      const changes = [];
      if (this.answers.category !== 'any' && product.category !== this.answers.category) changes.push('category');
      if (this.answers.personal === 'yes' && (!this.personal(product) || /sin texto|sem texto|without text|sin grabado|sem gravacao/.test(normalize(variant.titulo)))) changes.push('personal');
      if (this.answers.personal === 'no' && this.personal(product) && !/sin texto|sem texto|without text|sin grabado|sem gravacao/.test(normalize(variant.titulo))) changes.push('personal');
      if (this.answers.finish !== 'any' && this.finish(variant, product) !== this.answers.finish) changes.push('finish');
      if (this.answers.budget !== 'any' && variant.precio > Number(this.answers.budget)) changes.push('budget');
      return changes;
    }
    alternatives(products) {
      // Preferences remain unchanged. Alternatives disclose every exception and require a PDP review.
      const open = {...this.answers, category: 'any', personal: 'any', finish: 'any', budget: 'any'};
      let candidates = this.rank(products, open);
      const sameCategory = candidates.filter(entry => this.answers.category === 'any' || entry.product.category === this.answers.category);
      if (sameCategory.length) candidates = sameCategory;
      const cost = (changes, variant) => changes.length * 10000 + changes.reduce((sum,key) => sum + ({category:4000,personal:400,finish:200,budget:100}[key]), 0) +
        (changes.includes('budget') ? Math.min(99, (variant.precio - Number(this.answers.budget)) / 100) : 0);
      return candidates.map(entry => {
        const options = this.variants(entry.product, open).map(variant => {
          const changes = this.deviations(entry.product, variant);
          return {variant, changes, distance: cost(changes, variant)};
        }).sort((a,b) => a.distance-b.distance || a.variant.precio-b.variant.precio);
        return {...entry, ...options[0]};
      }).sort((a,b) => a.distance-b.distance || b.score-a.score || a.variant.precio-b.variant.precio || a.product.handle.localeCompare(b.product.handle));
    }
    async selection(products, signal) {
      const exact = this.rank(products);
      if (exact.length) return exact;
      const handles = this.collection({...this.answers, personal: 'any'});
      if (JSON.stringify(handles) !== JSON.stringify(this.collection())) {
        products = [...new Map([...products, ...await this.catalog(signal, handles)].map(p => [p.handle,p])).values()];
        const recovered = this.rank(products);
        if (recovered.length) return recovered;
      }
      let alternatives = this.alternatives(products);
      if (!alternatives.length) {
        const broad = this.answers.catalog === 'men' ? 'joyas-de-hombre' : 'todas-las-joyas';
        products = await this.catalog(signal, broad);
        const recovered = this.rank(products);
        if (recovered.length) return recovered;
        alternatives = this.alternatives(products);
      }
      return alternatives;
    }
    changeLabel(key, product, variant) {
      if (key === 'category') return this.t('alternative_category', {category: this.label('category', product.category)});
      if (key === 'personal') return this.t(this.personal(product) && !/sin texto|sem texto|without text|sin grabado|sem gravacao/.test(normalize(variant.titulo)) ? 'alternative_personal_yes' : 'alternative_personal_no');
      if (key === 'finish') {
        const finish = this.finish(variant, product);
        return this.t(finish === 'other' ? 'alternative_finish_unknown' : 'alternative_finish', {finish: this.label('finish', finish)});
      }
      return this.t('alternative_budget', {difference: this.amount(variant.precio-Number(this.answers.budget))});
    }
    clearLoadingStages() {
      for (const timer of this.loadingStages || []) clearTimeout(timer);
      this.loadingStages = [];
    }
    loadingView(delay) {
      this.panel.innerHTML = `<div class="qz-state qz-search-state"><div class="qz-search-mark" aria-hidden="true"><span></span><i></i></div><h2 tabindex="-1">${escape(this.t('loading_title'))}</h2><div class="qz-search-progress" aria-hidden="true" style="--qz-search-duration:${delay}ms"><span></span></div><p class="qz-search-status" role="status" aria-live="polite">${escape(this.t('loading_help'))}</p></div>`;
      const status = this.panel.querySelector('.qz-search-status');
      const update = key => { if (status && this.phase === 'loading') status.textContent = this.t(key); };
      this.clearLoadingStages();
      this.loadingStages = [
        setTimeout(() => update('loading_compare'), Math.max(350, delay * .34)),
        setTimeout(() => update('loading_stock'), Math.max(700, delay * .7))
      ];
    }
    async results(restoring = false) {
      this.trackVisit();
      const generation = ++this.generation;
      this.abort?.abort(); this.abort = new AbortController();
      const controller = this.abort;
      this.index = this.steps.length; this.phase = 'loading'; this.loading = true;
      this.frame();
      const delay = restoring ? 0 : Math.max(0, Number(this.config.searchDelay) || 3000);
      this.loadingView(delay);
      this.panel.setAttribute('aria-busy', 'true');
      if (!restoring) this.focusHeading();
      const timeout = setTimeout(() => controller.abort(), 30000);
      try {
        const wait = new Promise(resolve => setTimeout(resolve, delay));
        const [products] = await Promise.all([this.catalog(controller.signal), window.LPMQuizTracking?.loadModel()]);
        if (generation !== this.generation || !this.isConnected) return;
        this.recommendations = await this.selection(products, controller.signal);
        if (generation !== this.generation || !this.isConnected) return;
        await wait;
        if (generation !== this.generation || !this.isConnected) return;
        this.panel.querySelector('.qz-search-progress')?.classList.add('is-ready');
        this.shown = restoring ? (this.restoreShown || 4) : 4;
        const tracking = window.LPMQuizTracking;
        if (tracking?.allowed()) {
          if (!tracking.context()) tracking.start(this.quizType, this.config.currency, this.config.locale, this.answers);
          const context = tracking.context();
          const segment = [this.quizType, this.config.currency, this.answers.catalog, this.answers.category, this.answers.style].join(':');
          const scores = tracking.model().segments[segment] || {};
          if (!this.recommendations.some(entry => entry.changes?.length) && parseInt(context.run.slice(0, 8), 16) % 5 !== 0) {
            // Learning can only break ties within the explicit-style tier. Hard filters are already applied.
            this.recommendations.forEach(entry => {
              const boost = Number(scores[entry.product.handle]);
              if (Number.isFinite(boost)) entry.score += Math.max(0, Math.min(10, boost));
            });
            this.recommendations.sort((a,b) => b.score - a.score || a.product.handle.localeCompare(b.product.handle));
          }
          if (!restoring || !context.completed) tracking.complete(this.answers, this.recommendations.slice(0,4).map((entry,index) => this.productEvent(entry,index)));
        }
        this.phase = 'results';
        this.renderResults(!restoring);
        if (restoring) requestAnimationFrame(() => scrollTo({top: this.restoreScroll || 0, behavior: 'instant'}));
        this.saveState();
      } catch {
        controller.abort();
        if (generation !== this.generation || !this.isConnected) return;
        this.panel.innerHTML = `<div class="qz-state"><h2 tabindex="-1">${escape(this.t('error_title'))}</h2><p>${escape(this.t('error_help'))}</p><button type="button" class="qz-cta" data-retry>${escape(this.t('retry'))}</button><a class="qz-fallback" href="${escape(this.root)}collections/todas-las-joyas">${escape(this.t('browse'))}</a></div>`;
        this.focusHeading();
      } finally {
        clearTimeout(timeout);
        this.clearLoadingStages();
        if (generation === this.generation) { this.loading = false; this.panel.setAttribute('aria-busy', 'false'); }
      }
    }
    chips() {
      return `<div class="qz-chips">${this.steps.filter(key => key !== 'recipient').map(key => `<button type="button" class="qz-chip" data-edit="${key}" aria-label="${escape(this.t('edit', {answer: this.label(key, this.answers[key])}))}">${escape(this.label(key, this.answers[key]))} <span aria-hidden="true">↗</span></button>`).join('')}</div>`;
    }
    pending(product) {
      if (!Array.isArray(product.opciones)) return this.t('choose_options');
      if (product.opciones.some(name => /talla|tamano|size|taille|grosse|tamanho/.test(normalize(name)))) return this.t('choose_size');
      if (product.opciones.some(name => !finishOption(name) && (!/^(title|titulo)$/.test(normalize(name)) || product.variantes.some(variant => !/^default title$/i.test(variant.titulo || variant.t))))) return this.t('choose_options');
      if (this.answers.finish === 'any' && product.variantes.length > 1) return this.t('choose_finish');
      return '';
    }
    destination(product, variant) {
      // Shopify may return unprefixed p.url in alternate views. Keep the active locale.
      const url = new URL(`${this.root}products/${encodeURIComponent(product.handle)}`, location.origin);
      url.searchParams.set('variant', variant.id);
      return url.pathname + url.search;
    }
    card(entry, index) {
      const {product, variant, match, traits = [], changes = []} = entry;
      const personal = this.personal(product) && !/sin texto|sem texto|without text|sin grabado|sem gravacao/.test(normalize(variant.titulo));
      let pending = this.pending(product);
      if (!variant.foto && product.variantes.length > 1 && !pending) pending = this.t('check_finish');
      const href = escape(this.destination(product, variant));
      const photo = this.safeImage(variant.foto) || this.safeImage(product.foto);
      const name = variant.titulo || variant.t || '';
      const reasons = [];
      if (traits.length) reasons.push(this.t('reason_' + traits[0]));
      if (match) reasons.push(this.t(`reason_${this.answers.style}`));
      if (this.answers.finish !== 'any' && !changes.includes('finish')) reasons.push(this.label('finish', this.answers.finish));
      if (personal) reasons.push(this.t('reason_personal'));
      else if (this.answers.personal === 'no' && !changes.includes('personal')) reasons.push(this.t('reason_plain'));
      if (this.answers.budget !== 'any' && !changes.includes('budget')) reasons.push(this.t('reason_budget'));
      if (!reasons.length) reasons.push(this.label('category', product.category));
      const price = this.amount(variant.precio);
      return `<article class="qz-card${changes.length ? ' qz-card--alternative' : ''}" data-product="${escape(product.handle)}">
        <p class="qz-card-label">${escape(this.t(changes.length ? 'alternative_pick' : this.answers.style !== 'any' && !match ? 'different_style' : index === 0 ? 'first_pick' : 'alternative'))}</p>
        <a class="qz-card-image" href="${href}" tabindex="-1" aria-hidden="true"><img src="${escape(photo)}" alt="" width="600" height="600" loading="${index === 0 ? 'eager' : 'lazy'}"></a>
        <div class="qz-info">${changes.length ? `<ul class="qz-changes">${changes.map(key => `<li>${escape(this.changeLabel(key, product, variant))}</li>`).join('')}${this.answers.style !== 'any' && !match ? `<li>${escape(this.t('different_style'))}</li>` : ''}</ul>` : ''}<h3><a href="${href}">${escape(product.titulo)}</a></h3>
          ${name && !/^default title$/i.test(name) ? `<p class="qz-selection">${escape(name)}</p>` : ''}
          <p class="qz-price">${escape(pending ? this.t('price_from', {amount: price}) : price)}</p>
          ${pending ? `<p class="qz-selection">${escape(this.t('variant_note'))}</p>` : ''}
          ${!variant.foto && product.variantes.length > 1 ? `<p class="qz-image-note">${escape(this.t('image_note'))}</p>` : ''}
          <details class="qz-why"><summary>${escape(this.t('why'))}</summary><ul>${reasons.slice(0, 3).map(reason => `<li>${escape(reason)}</li>`).join('')}</ul></details>
          ${personal ? `<p class="qz-time">${escape(this.t(product.kind === 'cut' ? 'cut_time' : 'engraved_time'))}</p>` : ''}
          ${changes.length || personal || pending ? `<a class="qz-cta" href="${href}">${escape(changes.length ? this.t('review_alternative') : personal ? this.t('personalize') : pending)}</a>` : `<button type="button" class="qz-cta" data-add="${variant.id}" data-handle="${escape(product.handle)}">${escape(this.t('add'))}</button>`}
          <p class="qz-error" role="alert" hidden></p><a class="qz-cart-link" href="${escape(this.root)}cart" hidden>${escape(this.t('cart'))}</a>
        </div></article>`;
    }
    renderResults(focus = true) {
      this.phase = 'results';
      this.frame();
      const noResults = !this.recommendations.length;
      const alternatives = this.recommendations.some(entry => entry.changes?.length);
      this.classList.toggle('qz--empty', noResults);
      const relation = this.answers.relation || 'other';
      const context = this.answers.recipient !== 'self' && this.answers.occasion !== 'any' ? this.t(`context_${this.answers.occasion}`) : '';
      this.panel.innerHTML = `<div class="qz-question qz-result-head"><p class="qz-eyebrow">${escape(this.t('confidence_' + this.answers.buyer))}</p><h2 tabindex="-1">${escape(this.t(noResults ? 'no_results' : alternatives ? 'alternatives_title' : (this.quizType === 'personal' ? 'profile_' + this.answers.personality : 'result_' + relation)))}</h2>${alternatives ? '' : `<p>${escape(this.t(noResults ? 'no_results_help' : 'result_help'))}</p>`}${context ? `<p class="qz-context">${escape(context)}</p>` : ''}<details class="qz-filters"${noResults || (this.filtersOpen ?? matchMedia('(min-width: 801px)').matches) ? ' open' : ''}><summary>${escape(this.t('filters'))}</summary>${this.chips()}</details></div>
        ${alternatives ? `<p class="qz-note qz-alternatives-note" role="status">${escape(this.t('alternatives_help'))}</p>` : ''}
        ${!noResults && this.answers.style !== 'any' && !this.recommendations.some(entry => entry.match) ? `<p class="qz-note">${escape(this.t('style_fallback'))}</p>` : ''}
        ${!noResults && !alternatives && this.recommendations.length < 4 ? `<p class="qz-note">${escape(this.t('few_results', {count: this.recommendations.length}))}</p>` : ''}
        <div class="qz-grid">${this.recommendations.slice(0, this.shown).map((entry, index) => this.card(entry, index)).join('')}</div>
        ${this.emailForm()}
        ${this.recommendations.length > this.shown ? `<button type="button" class="qz-cta qz-more" data-more>${escape(this.t('more'))}</button>` : ''}
        <div class="qz-result-nav"><button type="button" class="qz-text-button" data-edit="${this.steps[0]}">${escape(this.t('edit_answers'))}</button><button type="button" class="qz-text-button" data-reset>${escape(this.t('restart'))}</button><a class="qz-fallback" href="${escape(this.root)}collections/todas-las-joyas">${escape(this.t('browse'))}</a></div>`;
      // Re-rendering 'more' must not re-enable an already confirmed addition.
      for (const button of this.panel.querySelectorAll('[data-add]')) {
        if (this.added?.has(button.dataset.add)) this.confirmAdded(button);
        else if (this.adding?.has(button.dataset.add)) { button.disabled = true; button.textContent = this.t('adding'); }
      }
      this.observeCards();
      if (focus) this.focusHeading();
    }
    emailForm() {
      if (!this.config.emailEnabled || !this.recommendations.length) return '';
      return `<section class="qz-email-save"><h2>${escape(this.t('email_title'))}</h2><p>${escape(this.t('email_save_help'))}</p><form data-qz-email><div class="qz-email-actions"><label class="qz-field"><span>${escape(this.t('email_label'))}</span><input type="email" name="email" autocomplete="email" inputmode="email" maxlength="254" placeholder="nombre@email.com" required></label><button type="submit" class="qz-cta">${escape(this.t('email_send'))}</button></div><div hidden aria-hidden="true"><input name="website" tabindex="-1" autocomplete="off"></div><p class="qz-email-note">${escape(this.t('email_notice'))} <a href="${escape(this.root)}policies/privacy-policy">${escape(this.t('privacy_link'))}</a></p><p class="qz-email-status" role="status" aria-live="polite"></p></form></section>`;
    }
    async sendEmail(form) {
      if (this.emailSending || !form.reportValidity()) return;
      this.emailSending = true;
      const emailRun = this.trackEmail('email_submit');
      const button = form.querySelector('button'), status = form.querySelector('[role=status]');
      button.disabled = true; status.textContent = this.t('email_sending');
      const delivery = {email: form.elements.email.value.trim(), website: form.elements.website.value, emailRun};
      return this.deliverEmail(delivery, form);
    }
    async deliverEmail(delivery, form) {
      this.emailSending = true;
      const outcome = kind => {
        if (delivery.emailRun && window.LPMQuizTracking?.context()?.run === delivery.emailRun) this.trackEmail(kind);
      };
      const body = {email:delivery.email,website:delivery.website,consent:true,notice:'quiz-email-v2',answers:Object.fromEntries(Object.entries(this.answers).filter(([key]) => this.emailAnswered.has(key) && (key !== 'occasion' || this.answers.recipient !== 'self'))),type:this.quizType,locale:this.config.locale.toLowerCase().startsWith('pt')?'pt-pt':'es',products:this.recommendations.slice(0,4).map(({product,variant,changes=[]})=>({handle:product.handle,variant:Number(variant.id),changes}))};
      try {
        const response = await fetch('https://calor-two.vercel.app/api/quiz-email', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),signal:timeoutSignal(20000)});
        if (response.status !== 202) { outcome('email_error'); form.querySelector('[role=status]').textContent = this.t(response.status === 429 ? 'email_limit' : 'email_error'); form.querySelector('button').disabled = false; }
        else { outcome('email_accepted'); form.elements.email.value = ''; form.querySelector('[role=status]').textContent = this.t('email_success'); }
      } catch { outcome('email_error'); form.querySelector('[role=status]').textContent = this.t('email_error'); form.querySelector('button').disabled = false; }
      finally {
        this.emailSending = false;
      }
    }
    confirmAdded(button) {
      button.textContent = this.t('added'); button.disabled = true;
      button.closest('.qz-card').querySelector('.qz-cart-link').hidden = false;
    }
    async add(button) {
      if (button.disabled) return;
      const id = button.dataset.add;
      this.adding ||= new Set(); this.added ||= new Set();
      if (this.adding.has(id) || this.added.has(id)) return;
      this.adding.add(id); button.disabled = true; button.textContent = this.t('adding');
      const error = button.closest('.qz-card').querySelector('.qz-error'); error.hidden = true;
      const preferenceValues = {
        tipo: {necklace: 'collar', earrings: 'pendientes', bracelet: 'pulsera', ring: 'anillo', any: 'sorpresa'}[this.answers.category],
        acabado: {gold: 'oro', silver: 'plata', any: 'igual'}[this.answers.finish],
        grabado: {yes: 'si', no: 'no', any: 'igual'}[this.answers.personal],
        estilo: this.answers.style, presupuesto: this.answers.budget
      };
      const preferences = Object.entries(preferenceValues).map(([key, value]) => `${key}=${value}`).join(' · ');
      // Preserve the existing report contract, excluding identity, relationship and occasion.
      const attributes = {'Quiz': 'sí', 'Quiz respuestas': preferences, 'Quiz producto': button.dataset.handle};
      try {
        // Attribution is best effort and time-bounded; buying never depends on analytics.
        await window.LPMQuizTracking?.beforeBuy();
        await fetch(`${this.root}cart/update.js`, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({attributes}), signal: timeoutSignal(2500)}).catch(() => null);
        const response = await fetch(`${this.root}cart/add.js`, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: [{id: Number(id), quantity: 1}]})});
        if (!response.ok) throw new Error('add');
        this.added.add(id);
        const index = this.recommendations.findIndex(entry => String(entry.variant.id) === id);
        if (index >= 0) this.track('add', [this.productEvent(this.recommendations[index], index)]);
        const cart = await fetch(`${this.root}cart.js`).then(response => response.ok ? response.json() : null).catch(() => null);
        // /cart.js has no bundled sections; Prestige expects those on cart:change.
        if (cart && Array.isArray(cart.items)) document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (cart && !document.documentElement.classList.contains('ncd-active') && typeof window.__NCD_OPEN === 'function') window.__NCD_OPEN();
      } catch {
        if (!this.added.has(id)) {
          error.textContent = this.t('add_error'); error.hidden = false;
        }
      } finally {
        this.adding.delete(id);
        // The card may have been replaced while adding. Update its current instance too.
        const current = this.panel.querySelector(`[data-add="${id}"]`) || button;
        if (this.added.has(id)) this.confirmAdded(current);
        else {
          current.disabled = false; current.textContent = this.t('add');
          const currentError = current.closest('.qz-card').querySelector('.qz-error');
          currentError.textContent = this.t('add_error'); currentError.hidden = false;
        }
      }
    }
  }
  customElements.define('lpm-jewelry-quiz', JewelryQuiz);
})();
